<template>
  <div>
    <VSectionBar
      id="teachers-infomation"
      message="講師紹介"/>
    <v-container
      fluid>
      <v-row
        justify=center
        >
        <v-col
          cols=12
          md=10>
          <VTeacherProfileCarousel/>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import VSectionBar from '@/components/molecules/VSectionBar.vue'
import VTeacherProfileCarousel from '@/components/organisms/lp/VTeacherProfileCarousel.vue'

export default {
  name: 'VTeachersProfile',
  components: {
    VSectionBar,
    VTeacherProfileCarousel
  }
}
</script>